module.exports = __webpack_public_path__ + "img/image22.0e1d8928.png";